import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

export const FullscreenPanoramaBase = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1200;
`

export const FullscreenPanoramaBackButton = styled.div`
  position: fixed;
  left: 44px;
  top: 20px;
  z-index: 1202;

  display: flex;
  align-items: center;
  min-height: 44px;
  min-width: 44px;
  padding-left: env(safe-area-inset-left, 0);

  user-select: none;
  cursor: pointer;

  span {
    margin-left: 30px;
    color: white;
  }

  @media ${media.belowTablet} {
    left: 16px;
    top: auto;
    bottom: calc(88px + env(safe-area-inset-bottom, 0px));
    background: rgba(0, 0, 0, 0.45);
    border-radius: 4px;
    padding: 8px 12px;

    span {
      display: none;
    }

    img {
      margin: 0;
    }
  }
`

export const MinimapPopupDiv = styled.div`
  top: 24px;
  position: fixed;
  z-index: 1201;

  width: 400px;
  filter: drop-shadow(0px 5px 30px rgba(0, 0, 0, 0.25));

  @media ${media.belowTablet} {
    width: min(400px, calc(100vw - 32px));
    top: max(12px, env(safe-area-inset-top, 12px));
    left: 16px;
    right: 16px;
    margin: 0 auto;
  }
`

interface MinimapPopupHeaderProps {
  transparent?: boolean
}

export const MinimapPopupHeader = styled.div<MinimapPopupHeaderProps>`
  background-color: ${props => (props.transparent ? 'transparent' : '#f8f8f8')};
  padding: 11px 16px;
  border-radius: 2px 2px 0 0;

  @media ${media.belowTablet} {
    padding: 8px 12px;
    font-size: 12px;
  }
`

export const MinimapPopupImage = styled.div`
  border-radius: 0 0 2px 2px;
  display: block;
  background-color: white;
  overflow: hidden;

  height: 220px;
  max-width: 100%;

  @media ${media.belowTablet} {
    height: 140px;
  }
`

export const SplitScreenContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${media.belowTablet} {
    flex-direction: column;
  }
`
